import API from "../axiosConfig";

export const getDevices = async () => {
  try {
    const response = await API.get("/devices");
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};
export const createDevice = async (deviceData) => {
  try {
    const response = await API.post("/devices", deviceData);
    return response.data;
  } catch (error) {
    console.error("Error creating device:", error);
    throw error;
  }
};

export const updateDevice = async (deviceId, deviceData) => {
  try {
    const response = await API.put(`/devices/${deviceId}`, deviceData);
    return response.data;
  } catch (error) {
    console.error("Error updating device:", error);
    throw error;
  }
};

export const deleteDevice = async (deviceId) => {
  try {
    const response = await API.delete(`/devices/${deviceId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting device:", error);
    throw error;
  }
};
